import { Component, OnInit, Input, Inject } from '@angular/core';
import { CommonService } from '../../_services/common.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../../_services/api-data.service';
import { ToastService } from '../../_services/toast.service';
import { URLS } from '../../_config/api.config';
import { DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { TwoFAToggleComponent } from '../two-fa-toggle/two-fa-toggle.component';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  public subscription = new Subscription();
  currencySymbol: string = "$";
  showFilter: boolean = false;
  totalNotificationsCount: any;
  isLoading: boolean = false;
  showLoader: boolean = false;

  notificationsData = [];

  @Input() showHeader!: boolean;
  constructor(
    public commonService: CommonService,
    private dataService: ApiService,
    private toastService: ToastService,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngOnInit() {
    let is2fa = localStorage.getItem('is_2fa_enabled');
    if (is2fa && is2fa == 'true') {
      this.commonService.twoFaEnabled = true;
    }
    const element = this.document.querySelector('#scrollId');
    if (element) {
      element.scrollIntoView();
    }
    this.showHeader = true;
    this.getNotificationsList();
  }

  ionViewWillEnter() {
    this.showHeader = true;
  }

  openFilters() {
    this.showFilter = !this.showFilter;
  }

  getNotificationsList() {
    const params = {
      dropdown: true,
    };
    this.showLoader = true;
    this.subscription.add(
      this.dataService.get(URLS.getNotifications, params).subscribe(
        (data) => {
          if (data['code'] == 200) {
            this.totalNotificationsCount = parseInt(data['data']['total_count'])
            if (data['data'] && data['data']['notificationDetails'].length) {
              let list = data['data'] && data['data']['notificationDetails'].length ? data['data']['notificationDetails'] : [];
              this.notificationsData = [];
              list.forEach((data: any) => {
                let obj = {
                  notification_type_id: data.notification_type_id ? data.notification_type_id : '',
                  notification_type: this.commonService.domDirectionLTR ? data.notification_type_en ? data.notification_type_en : '' : data.notification_type_ar ? data.notification_type_ar : '',
                  is_enabled: data.is_enabled,
                  img_url: data.concat ? data.concat : '',
                };
                this.notificationsData.push(obj);
              });
            }
            this.showLoader = false;
          } else {
            if (data['code'] != 204) {
              this.showLoader = false;
              this.toastService.displayToast(data['message'], null, 'danger');
            }
          }
        },
        (error) => {
          this.showLoader = false;
          this.toastService.displayToast(error['message'], null, 'danger');
        }
      )
    );
  }

  toggle2fa() {
    this.dialog.open(TwoFAToggleComponent, {
      width: '440px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      panelClass: 'two-fa-dialog',
    });
  }
}
